import React from 'react';
import { Footer } from '@agilytics/components';
import { Header, UserActions } from '@agilytics/containers';

export default function AppLayout(props) {
  return (
    <>
      <Header />
      <UserActions />
      {props.children}
      <Footer />
    </>
  );
}
